import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { Referral } from '../models/referral';

export class ReferralService extends BaseService<Referral> {
  override model = Referral;
  override modelName = 'referral';
  override modelLabel = 'Referral';

  async sendReferral(
    referrals: any[],
  ): Promise<ApiResponse<any>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}/send`,
      data: { referrals },
    });

    return await this.requestItem(request, Referral);
  }
}
